import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationStore } from '@argo/authentication';
import {
  ScaModuleTitleComponent,
  ScaAlertComponent,
  ScaIconComponent,
  ScaButtonComponent,
  ScaBadgeComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-protected-route',
  standalone: true,
  imports: [
    CommonModule,
    ScaModuleTitleComponent,
    ScaAlertComponent,
    ScaIconComponent,
    ScaButtonComponent,
    ScaBadgeComponent
  ],
  template: `
    <div style="padding: 2rem; max-width: 900px; margin: 0 auto;">
      <sca-module-title
        title="¡Acceso concedido!"
        subtitle="Has accedido correctamente a una ruta protegida"
        icon="check_circle">
      </sca-module-title>

      <sca-alert variant="success" style="margin-bottom: 1.5rem;">
        <sca-icon icon="security" size="24px" left />
        Esta ruta está protegida por <code>authGuardCanActivate</code>
      </sca-alert>

      <div scaCardWorkshop>
        <div scaCardWorkshopHeader>
          <sca-icon icon="info" size="32px" />
          <h2 scaCardWorkshopTitle>Información del Guard</h2>
        </div>
        <div scaCardWorkshopBody>
          <table class="info-table">
            <tr>
              <td><strong>Guard utilizado:</strong></td>
              <td><code>authGuardCanActivate</code></td>
            </tr>
            <tr>
              <td><strong>Usuario autenticado:</strong></td>
              <td><code>{{ auth.user().preferred_username || auth.user().email || 'N/A' }}</code></td>
            </tr>
            <tr>
              <td><strong>Fase de autenticación:</strong></td>
              <td><sca-badge>{{ auth.phase() }}</sca-badge></td>
            </tr>
            <tr>
              <td><strong>Estado logged:</strong></td>
              <td><sca-badge [variant]="auth.logged() ? 'success' : 'error'">{{ auth.logged() }}</sca-badge></td>
            </tr>
          </table>
        </div>
      </div>

      <div scaCardWorkshop style="margin-top: 1.5rem;">
        <div scaCardWorkshopHeader>
          <sca-icon icon="help" size="32px" />
          <h3 scaCardWorkshopTitle>¿Cómo funciona?</h3>
        </div>
        <div scaCardWorkshopBody>
          <p style="margin-bottom: 1rem;">
            Esta ruta está protegida por el <strong>authGuardCanActivate</strong> que:
          </p>
          <ul style="margin: 0; padding-left: 1.5rem;">
            <li>✅ Espera a que el AuthenticationStore esté listo (async)</li>
            <li>✅ Verifica que el usuario esté autenticado</li>
            <li>✅ Redirige a login si no hay autenticación</li>
            <li>✅ Permite el acceso solo si logged === true</li>
          </ul>
        </div>
        <div scaCardWorkshopFooter>
          <button sca-button (click)="goBack()">
            <sca-icon icon="arrow_back" size="20px" left />
            Volver a Auth Test
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .info-table {
      width: 100%;
      border-collapse: collapse;
    }

    .info-table td {
      padding: 0.75rem;
      border-bottom: 1px solid #eee;
    }

    .info-table td:first-child {
      width: 40%;
      font-weight: 500;
    }

    .info-table tr:last-child td {
      border-bottom: none;
    }
  `]
})
export class ProtectedRouteComponent {
  readonly auth = inject(AuthenticationStore);
  private router = inject(Router);

  goBack() {
    this.router.navigate(['/test/auth']);
  }
}
